import { Component, OnInit, ViewChild } from '@angular/core';
import { SalesService } from '../../../../services/sales.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Product, SalesOrder, UpdateInventory, gridPageRequest } from '../../../../model/common/common.model';
import _ from 'lodash';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { ReportLookupComponent } from '../../../Reports/report-lookup/report-lookup.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { ReportCenterService } from '../../../../services/report-center.service';
import { InventoryService } from '../../../../services/inventory.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-dispatch-sales-order',
  standalone: true,
  imports: [SharedModule,CommonModule],
  templateUrl: './dispatch-sales-order.component.html',
  styleUrl: './dispatch-sales-order.component.scss'
})
export class DispatchSalesOrderComponent implements OnInit{


  constructor(private router:Router, private salesService:SalesService, private confirmationService:ConfirmationService, private inventoryService: InventoryService,
  private messageService:MessageService, public dialogService: DialogService, public ref: DynamicDialogRef,private reportService : ReportCenterService){}
  @ViewChild('dt1') dt1: Table | undefined;

  loader: boolean = false;
  searchKey: any;
  listInvoice: SalesOrder[] = [];
  selectedOrder: SalesOrder[] = [];
  paginator: boolean | undefined;
 products: Product[] = [];    
  allProductData: Product[] = [];
  pageRequest: gridPageRequest = {
    pageIndex:0,
    pageSize: 50,
    id: 0
  }

  ngOnInit(): void {
    this.getList();
    this.searchEffect();
    document.title = 'Dispatch Order List ';
  }

  create(){
    this.router.navigate(['/home/CreateInvoice']);
  }

  loadOrderList(event: any) {
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchOrder();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getList();
    }
  }

  getList(){
    // this.loader = true;
    this.salesService.getSalesOrderByStatus('SHIPPING',this.pageRequest).subscribe(
      (data: any) => {
        if (data) {
         // console.log(data);
          this.listInvoice = data.salesOrder;
          // this.loader = false;
          this.searchKey = undefined;
        } else {
          console.log(data);
          // this.loader = false;
        }
      },
      (error: any) => {
        console.log(error);
        // this.loader = false;
      }
    );
  }

  view(data?:any){
    if(data){
      // const Data = JSON.stringify(data);
      this.router.navigate(['/home/ViewdispatchSalesOrder'], {queryParams: { 'salesOrderId': data.salesOrderId },skipLocationChange: false,});
    }else{
      const Data = JSON.stringify(this.selectedOrder[0].salesOrderId);
      // console.log(Data);
      this.router.navigate(['/home/ViewdispatchSalesOrder'], {queryParams: { 'salesOrderId': Data },skipLocationChange: false,});
    }
  }

async delete() {
  this.confirmationService.confirm({
    header: 'Are you sure?',
    message: 'Please confirm to proceed.',
    accept: async () => {
      this.loader = true;

      try {
        for (const orderRaw of this.selectedOrder) {
          const order: SalesOrder = this.mapToSalesOrder(orderRaw);
          const salesOrderId = order.salesOrderId;
          const salesOrderNumber = order.SalesOrderNumber;
          const warehouseId = order.WarehouseId;

          let lineItemData: any[] = [];
          try {
            lineItemData = await firstValueFrom(
              this.salesService.getSalesOrderLineItem(salesOrderNumber)
            );
          } catch (err) {
            console.error(`Failed to get line items for ${salesOrderNumber}:`, err);
          }

          try {
            await firstValueFrom(this.salesService.deleteSalesOrder([salesOrderId]));
          } catch (delErr) {
            console.error(`Failed to delete order ${salesOrderNumber}:`, delErr);
            continue; 
          }

          try {
            const lineItemIds = lineItemData.map(item => item.salesOrderLineItemId);
            if (lineItemIds.length) {
              await firstValueFrom(
                this.salesService.deleteSalesOrderLineItem(lineItemIds)
              );
            }
          } catch (lineDelErr) {
            console.error(`Failed to delete line items for ${salesOrderNumber}:`, lineDelErr);
          }

          const inventoryTasks = lineItemData.map(product => {
            const shippedQty = product.shipedQuantity ?? product.orderQuantity ?? 0;

            const inventory: UpdateInventory = {
              productId: product.productId,
              warehouseId: _.toNumber(warehouseId),
              productCode: product.productCode,
              status: "SHIPPING",
              transactionNo: salesOrderNumber,
              transactionType: "",
              quantity: shippedQty,
              createdBy: localStorage.getItem('username') || '',
              transactionDate: new Date(),
              createdDate: new Date(),
            };
            
            return firstValueFrom(this.inventoryService.updateInventoryNew(inventory));
          });

          try {
            await Promise.all(inventoryTasks);
          } catch (invErr) {
            console.error(`Inventory update failed for order ${salesOrderNumber}:`, invErr);
          }
        }

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Deleted and inventory updated successfully.'
        });

        this.selectedOrder = [];
        this.products = [];
        this.allProductData = [];
        await this.getList();

      } catch (err) {
        console.error('Delete / inventory update failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Error occurred while deleting order or updating inventory.'
        });
      } finally {
        this.loader = false;
      }
    },
    reject: () => {
    }
  });
}


 mapToSalesOrder(order: any): SalesOrder {
    return {
      salesOrderId: order.salesOrderId,
      SalesOrderNumber: order.salesOrderNumber || order.SalesOrderNumber,
      OrderType: order.orderType || order.OrderType,
      CustomerId: order.customerId?.toString() || order.CustomerId,
      SalesOrderDate: new Date(order.salesOrderDate || order.SalesOrderDate),
      SalesOrderInvoiceDate: new Date(order.salesOrderInvoiceDate || order.SalesOrderInvoiceDate || new Date()),
      ShipmentDate: new Date(order.shipmentDate || order.ShipmentDate || new Date()),
      SalespersonId: order.salespersonId?.toString() || order.SalespersonId,
      SalespersonCode: order.salespersonCode || order.SalespersonCode,
      BillToCustomerId: order.billToCustomerId?.toString() || order.BillToCustomerId,
      ShipToCustomerId: order.shipToCustomerId?.toString() || order.ShipToCustomerId,
      BillToCustomerCode: order.billToCustomerCode || order.BillToCustomerCode,
      ShipToCustomerCode: order.shipToCustomerCode || order.ShipToCustomerCode,
      QuoteExpiration: order.quoteExpiration ? new Date(order.quoteExpiration) : new Date(),
      WarehouseId: order.warehouseId?.toString() || order.WarehouseId,
      PurchaseOrderNumber: order.purchaseOrderNumber || order.PurchaseOrderNumber,
      OrderTotal: order.orderTotal || order.OrderTotal,
      CGSTTotal: order.cgstTotal || order.CGSTTotal,
      SGSTTotal: order.sgstTotal || order.SGSTTotal,
      IGSTTotal: order.igstTotal || order.IGSTTotal,
      totalWeight: order.totalWeight || order.totalWeight,
      DispatchDocNo: order.dispatchDocNo || order.DispatchDocNo,
      ShippingStatus: order.shippingStatus || order.ShippingStatus,
      SalesOrderStatus: order.salesOrderStatus || order.SalesOrderStatus,
      BackOrderStatus: order.backOrderStatus || order.BackOrderStatus,
      SalesTaxTotal: order.salesTaxTotal || order.SalesTaxTotal,
      MarginTotal: order.marginTotal || order.MarginTotal,
      ProfitTotal: order.profitTotal || order.ProfitTotal,
      LabourTotal: order.labourTotal || order.LabourTotal,
      FreightTotal: order.freightTotal || order.FreightTotal,
      IsGlPosted: order.isGlPosted || order.IsGlPosted,
      InvoiceYear: order.invoiceYear || order.InvoiceYear,
      InvoiceMonth: order.invoiceMonth || order.InvoiceMonth,
      BackOrderTotal: order.backOrderTotal || order.BackOrderTotal,
      GLError: order.glError || order.GLError,
      IsLabourTaxable: order.isLabourTaxable || order.IsLabourTaxable,
      IsFreightTaxable: order.isFreightTaxable || order.IsFreightTaxable,
      IsActive: order.isActive || order.IsActive,
      CreatedBy: order.createdBy || order.CreatedBy,
      UpdatedBy: order.updatedBy || order.UpdatedBy,
      TermsCode: order.termsCode || order.TermsCode,
      PaymentTermsId: order.paymentTermsId || order.PaymentTermsId,
      MotorVehicleNo: order.motorVehicleNo || order.MotorVehicleNo,
      BillOfLading: order.billOfLading || order.BillOfLading,
      LRRRNo: order.lrrrNo || order.LRRRNo,
      DispatchThrough: order.dispatchThrough || order.DispatchThrough,
      orderDate: new Date(order.orderDate || order.orderDate),
      requestedDate: new Date(order.requestedDate || order.requestedDate),
      deliveryNote: order.deliveryNote || order.DeliveryNote,
      ServiceCallCode: order.serviceCallCode || order.ServiceCallCode,
      ReferenceNumber: order.referenceNumber || order.ReferenceNumber,
      Destination: order.destination || order.Destination,
      TermsOfDelivery: order.termsOfDelivery || order.TermsOfDelivery,
      Status: order.status || order.Status,
      CustomerPODate:  order.customerPODate ? new Date(order.customerPODate) : new Date(),
      driverName: order.driverName,
      driverContact: order.driverContact,
      expDeliveryDate:  order.expDeliveryDate ? new Date(order.expDeliveryDate) : new Date(),
    };
  };

    searchOrder() {
  if (!this.searchKey) {
    this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a search keyword' });
    return;
  }

  this.salesService.SearchSalesOrder(this.searchKey).subscribe(
    (data: any) => {
      if (Array.isArray(data)) {
        this.listInvoice = data.filter((order: any) =>
          order.salesOrderStatus === 'SHIPPING');
        this.pageRequest.pageSize = this.listInvoice.length;
        this.paginator = false;

      } else if (data && Array.isArray(data.salesOrder)) {
        this.listInvoice = data.salesOrder.filter((order: any) =>
          order.salesOrderStatus === 'SHIPPING' );
        this.pageRequest.pageSize = this.listInvoice.length;
        this.paginator = false;

      } else {
        this.listInvoice = [];
      }

    },
    (error) => {
      console.error('Search error:', error);
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });
    }
  );
}


  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getList();
  }

showReport(value: any): void {
  const formCode = 'Pick';
  this.reportService.getReportName(formCode).subscribe({
    next: (report: any) => {
      const orderNumber = value.salesOrderNumber;
      const sanitizedOrderNumber = orderNumber.replace(/[^a-zA-Z0-9]/g, "_");
      document.title = sanitizedOrderNumber;
      this.ref = this.dialogService.open(ReportLookupComponent, {
        header: report.formName,
        width: '100%',
        data: {
          OrderNo: orderNumber,
          ReportName: sanitizedOrderNumber,  
          ReportPath: report.path
        }
      });

      this.ref.onClose.subscribe(() => {
        this.searchKey = '';
        document.title = 'Dispatch Order List '; 
      });
    },
    error: (err) => {
      console.error('Report not found for form code:', formCode, err);
    }
  });
}


  statusColors: { [key: string]: string } = {
    'Ready to Pick': '#28a745',
    'In Picking': '#007bff',
    'Picked': '#ff9800',
    'In Packing': '#6f42c1',
    'Dispatched': '#30f100ff'
  };


  getStatusColor(status: string): string {
    if (!status) return 'black';
    const key = status.split(' - ')[0].trim();
    return this.statusColors[key] || 'black';
  }


  placeholder: string = 'Search By ';
  private messages: string[] = ['Order No',	'Order Date',	'Bill To Customer',	'Ship To Customer',	'Order Total', 'Reqd Date'];    private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }


}